import { Checkbox, FormControlLabel, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { facilityRateCodes } from './Pricebook'

function RateCodeFilter({
  code,
  rateCodeFilter,
  setRateCodeFilter,
}: {
  code: number
  rateCodeFilter: any
  setRateCodeFilter: any
}) {
  return (
    <FormControlLabel
      sx={{ textWrap: 'nowrap !important' }}
      control={
        <Tooltip
          title={
            <Typography variant="h6">{facilityRateCodes[code].long}</Typography>
          }
        >
          <Checkbox
            checked={rateCodeFilter?.[code] || false}
            onChange={(e) => {
              setRateCodeFilter((r: any) => {
                return {
                  ...r,
                  [code]: e.target.checked,
                }
              })
            }}
          />
        </Tooltip>
      }
      label={facilityRateCodes[code].short}
      labelPlacement="start"
    />
  )
}

export default RateCodeFilter
